'use client';

import { FC, useMemo } from 'react';
import { Video, VideoProps } from './Video';
import { useScreenName } from '../../../../hooks/use-screen-name';
import { getResponsiveValue, type ResponsiveValue, type ScreenName } from '../../../../utils';
export type ResponsiveVideoProps = Omit<VideoProps, 'src' | 'poster'> & {
  src?: ResponsiveValue<VideoProps['src']>;
  poster?: ResponsiveValue<VideoProps['poster']>;
  ssrScreen?: ScreenName;
};

/**
 * A responsive proxy for the `Video` component.
 */
export const ResponsiveVideo: FC<ResponsiveVideoProps> = props => {
  let {
    src: srcArg,
    poster: posterArg,
    ssrScreen,
    ...rest
  } = props;
  let screen = useScreenName(ssrScreen);
  let src = useMemo(() => getResponsiveValue(srcArg, undefined, screen), [srcArg, screen]);
  let poster = useMemo(() => getResponsiveValue(posterArg, undefined, screen), [posterArg, screen]);
  return <Video {...rest} src={src} poster={poster} data-sentry-element="Video" data-sentry-component="ResponsiveVideo" data-sentry-source-file="ResponsiveVideo.tsx" />;
};